import { AuthService } from '@/api/services/AuthService';
import { BusinessService } from '@/api/services/BusinessService';
import { SelfEmployeeService } from '@/api/services/SelfEmployeeService';
import { PlatformsService } from '@/api/services/PlatformsService';
import { TaxModesService } from '@/api/services/TaxModes';
import { ReceiptImageService } from '@/api/services/ReceiptService'
import { ExternalService } from '@/api/services/External';
import { AdminService } from '@/api/services/Admin';
import { InternalService } from '@/api/services/Internal'

const services = {
  auth: new AuthService(),
  business: new BusinessService(),
  selfEmployee: new SelfEmployeeService(),
  platforms: new PlatformsService(),
  taxModes: new TaxModesService(),
  receipts: new ReceiptImageService(),
  external: new ExternalService(),
  admin: new AdminService(),
  internal: new InternalService(),
};

export default services;
